import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

export const usePlayContentId = (contentId: string) => {
    useInstanceEffect(
        (instance) => {
            if (instance.type === 'filmoscope') {
                instance.setPlayingContentId(contentId);
                return () => {
                    instance.setPlayingContentId(null);
                };
            }
        },
        [contentId]
    );
};
